export class Connection {
    constructor(linkModel, source, target) {
        this.linkModel = linkModel;
        this.source = source;
        this.target = target;
    }
}
